import { GA4Event } from "./GA4Event";

export default buildCartEvents;

function buildCartEvents(eventName, model) {
	const { attributes, products } = model;
	const event = new GA4Event(eventName, {
		currency: attributes.currency,
		value: parseFloat(attributes.totalvalue),
		step: attributes.step
	});
	const { eventData } = event;
	const items = [];
	if (products) {
		for (const product of products) {
			const itemData = event.buildItem(product);
			items.push(itemData);
		}
	}
	eventData.params['items'] = items;
	return eventData;
}
